export default class SubCast {
  id: string;
  name: string;
  namegujarati: string;

  constructor(data: Partial<SubCast> = {}) {
    this.id = data.id || "";
    this.name = data.name || "";
    this.namegujarati = data.namegujarati || "";
  }
}
